(function () {
    'use strict';
    'ngInject';

    angular.module('app.ctrls').controller('SignUpAffiliateCtrl', signUpAffiliateCtrl);

    function signUpAffiliateCtrl(
        $scope,
        $rootScope,
        $mdDialog,
        $location,
        UsersAPIService,
        vcRecaptchaService,
        blockUI
    ) {
        $rootScope.showHeader = false;
        $scope.showRegistrationForm = true;
        $scope.recaptchaPublicKey = '6LdxWcYUAAAAAE8LVGxSGubGleKfjYF5LqjKR9HP';

        $scope.signUp = function () {
            if (vcRecaptchaService.getResponse() === '') {
                $mdDialog.show(
                    $mdDialog
                        .alert()
                        .parent(document.body)
                        .clickOutsideToClose(true)
                        .title('User creation')
                        .textContent('Resolve the captcha first')
                        .ok('OK!')
                );
            } else {
                if ($scope.password === $scope.passwordConfirmation) {
                    blockUI.start();
                    UsersAPIService.registerUserAffiliate(
                        $scope.name,
                        $scope.username,
                        $scope.email,
                        $scope.password,
                        $scope.passwordConfirmation,
                        vcRecaptchaService.getResponse()
                    )
                        .then(function () {
                            // Show confirmation message
                            $scope.showRegistrationForm = false;
                            blockUI.stop();
                        })
                        .catch(function (err) {
                            blockUI.stop();
                            vcRecaptchaService.reload();
                            $mdDialog.show(
                                $mdDialog
                                    .alert()
                                    .parent(document.body)
                                    .clickOutsideToClose(true)
                                    .title('User creation')
                                    .textContent(err.data)
                                    .ok('OK!')
                            );
                        });
                } else {
                    $mdDialog.show(
                        $mdDialog
                            .alert()
                            .parent(document.body)
                            .clickOutsideToClose(true)
                            .title('Password error')
                            .textContent("Passwords don't match")
                            .ok('OK!')
                    );
                }
            }
        };

        $scope.goToLogin = function () {
            $location.path('/login');
        };
    }
})();
